$(document).ready(function () {
	controlNewsWidth();
});

function controlNewsWidth() {
	var columnHeaders = $('th');
	
	var columnSizes = [];
	columnHeaders.each(function() {
	var columnWidth = $(this).width();
		columnSizes.push(columnWidth);
	});
	
	var columnSelector = 0;
	var objects = $('.data').find('tr:first').find('td');
	objects.each(function() {
		$(this).width(columnSizes[columnSelector]);
		if (columnSelector == columnHeaders.length - 1) {
			columnSelector = 0;
		} else {
			columnSelector++;
		}
	});
}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
